import { useLocation, useNavigate } from 'react-router-dom';
import { APICore } from '../helpers/api/apiCore';
import { useUser } from '../hooks';
import useAuth from '../hooks/useAuth';
import axios from 'axios';
import { useEffect, useState } from 'react';
import {useAssets} from "../hooks/AssetsProvider";
import React from 'react';
import Swal from "sweetalert2";
import Loader from '../components/Loader';

type PrivateRouteProps = {
    component: React.ComponentType;
    roles: string[];
    requiredPermission?: string;
};

const PrivateRoute = ({
    component: RouteComponent,
    roles,
    requiredPermission,
    ...rest
}: PrivateRouteProps) => {
    const [isFirstEffectComplete, setIsFirstEffectComplete] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
    const location = useLocation();
    const [loggedInUser] = useUser();
    const [loading, setLoading] = useState(false);
    const { auth, setAuth } = useAuth();
    const {refetch} = useAssets();
    const navigate = useNavigate();
    const api = new APICore();

    const username = auth.username;
    const homePage = [
        '/',
        '/',
        '/',
        `/${username}`,
        '/tickets/bug',
        '/dashboard',
        '/dashboard',
        '/dashboard',
    ];
    const [isLoading, setIsLoading] = useState(true);
    const [redirectPath, setRedirectPath] = useState<string | null>(null);

    useEffect(() => {
        if (api.isUserAuthenticated() === false) {
            navigate('/login');
        } else if (!auth.email) {
            axios
                .get('/home/', { withCredentials: true })
                .then((response) => {
                    const {
                        main_role,
                        first_name,
                        last_name,
                        email,
                        projects,
                        users,
                        last_login,
                        username,
                        notifications,
                        available_roles,
                    } = response.data;
                    setAuth({
                        username,
                        last_login,
                        first_name,
                        last_name,
                        email,
                        main_role,
                        available_roles,
                        projects,
                        users,
                        notifications,
                        current_role: main_role
                    });
                    const storedProject = localStorage.getItem('Project');
                    if (!storedProject && projects?.length > 0) {
                        localStorage.setItem('Project', projects[0].id);
                    }
                    setLoading(true);
                    console.log("first useeffect");
                }).then(() => refetch())
                .catch((err) => {
                    setLoading(false);
                    console.log("error authentication", err);
                    setTimeout(() => {
                        navigate('/login');
                    }, 5000);
                })
                .finally(() => {
                    setIsLoading(false);
                    setLoading(false);
                    setIsFirstEffectComplete(true);
                });
        } else {
            setIsLoading(false);
            setIsFirstEffectComplete(true);
        }
    }, [auth.email, setAuth]);

 useEffect(() => {
        if (isFirstEffectComplete) {
            const userRoles = auth.current_role?.split(',').map(Number) || [];
            const userProjects = auth.projects || [];
            const isAuthorizedByRole = roles.some((role) => userRoles.includes(Number(role)));
            const hasProjectPermission = requiredPermission
                ? userProjects.some((project: any) => project[requiredPermission] === true)
                : true;

            if (!isAuthorizedByRole || !hasProjectPermission) {
                setIsAuthorized(false);

                const isDefaultHome = location.pathname === '/dashboard' || location.pathname ===`/${auth.username}` || location.pathname === '/tickets/bug';

                if (!isDefaultHome) {
                    Swal.fire({
                        title: 'Access Denied',
                        text: 'You do not have permission to access this page.',
                        icon: 'error',
                        backdrop: true,
                        showConfirmButton: false,
                        timer: 2000,
                        willOpen: () => {
                            document.body.classList.add("swal-open");
                        },
                        willClose: () => {
                            document.body.classList.remove("swal-open");
                        },
                    }).then(() => {
                        const fallbackRole = Math.min(...userRoles);
                        const redirectUrl = homePage[fallbackRole];
                        navigate(redirectUrl, { replace: true });
                    });
                } else {
                    // Silent redirect for dashboard
                    const fallbackRole = Math.min(...userRoles);
                    const redirectUrl = homePage[fallbackRole];
                    navigate(redirectUrl, { replace: true });
                }
            } else {
                setIsAuthorized(true);
            }
        }
    }, [roles, requiredPermission, isFirstEffectComplete, auth.current_role, auth.projects]);

    if (isLoading || redirectPath || isAuthorized === null) {
        return <Loader />;
    }

    if (isAuthorized === false) {
        return <Loader />;
    }

    return <RouteComponent />;
};

export default PrivateRoute;